import Vue from "vue"
import dayjs from 'dayjs'

Vue.filter('formatDate', (value, schema) => {
  return dayjs(value).format(schema)
})